module.exports = __webpack_public_path__ + "static/media/reposit.ac7066c9.svg";